import React from 'react';

import { Typography, makeStyles, createStyles } from '@material-ui/core';

import Page from '../../page/Page';
import RegionList from './RegionList';

const useStyles = makeStyles(() => createStyles({
  header: {
    paddingTop: '3rem',
    paddingBottom: '2rem',
  },
}));

const ShippingRegionsPage = () => {
  const classes = useStyles();

  return (
    <Page>
      <Typography className={classes.header} variant="h3">Regions</Typography>
      <RegionList />
    </Page>
  );
};

export default ShippingRegionsPage;
